import {API_DRIVER} from "../config/axios"

export interface IQuestionAnswerOption {
    id: string
    answer_en: string
    answer_al: string
    answer_mk: string
}

export interface IQuestionAnswerCreate {
    id?: string
    answer_en: string
    answer_al: string
    answer_mk: string
    is_correct: boolean
}

export interface IQuestion {
    id: string
    question_en: string
    question_al: string
    question_mk: string
    answers: IQuestionAnswerOption[]
}

export interface IQuestionAdminAnswer extends IQuestionAnswerOption {
    is_correct: boolean
}

export interface IQuestionAdmin {
    id: string
    question_en: string
    question_al: string
    question_mk: string
    answers: IQuestionAdminAnswer[]
}

export interface IQuestionCreateRequest {
    question_en: string
    question_al: string
    question_mk: string
    answers: IQuestionAnswerCreate[]
}

interface ISubmitQuestionAnswerResponse {
    question_id: string
    answer_id: string
    is_correct: boolean
}

const getQuestionsRequestUrl = (endpointUrl = "") => {
    return `/api/questions${endpointUrl}`
}

const QuestionService = {
    fetchQuestionsAdmin: () => {
        return API_DRIVER.get<IQuestionAdmin[]>(getQuestionsRequestUrl())
    },
    fetchRandomQuestion: () => {
        return API_DRIVER.get<IQuestion>(getQuestionsRequestUrl("/random"))
    },
    submitAnswer: (questionId: string, answerId: string) => {
        return API_DRIVER.post<ISubmitQuestionAnswerResponse>(
            getQuestionsRequestUrl("/answer"),
            {
                question_id: questionId,
                answer_id: answerId,
            }
        )
    },
    createQuestion: (payload: IQuestionCreateRequest) => {
        return API_DRIVER.post<IQuestionAdmin>(getQuestionsRequestUrl(), payload)
    },
    updateQuestion: (questionId: string, payload: IQuestionCreateRequest) => {
        return API_DRIVER.put<IQuestionAdmin>(getQuestionsRequestUrl(`/${questionId}`), payload)
    },
    deleteQuestion: (questionId: string) => {
        return API_DRIVER.delete(getQuestionsRequestUrl(`/${questionId}`))
    },
}

export default QuestionService
